export default "__VITE_ASSET__Cig0vJlr__"